import { OnInit, EventEmitter } from '@angular/core';
import { ViewService } from "../services/view.service";
import { View } from '../objects/ViewObject';
import { ConfirmationService } from '../services/confirmation.service';
import { ConversationService } from '../services/conversation.service';
import { ContextMenuService, ContextMenuComponent } from 'node_modules/ngx-contextmenu';
var TreeviewComponent = /** @class */ (function () {
    function TreeviewComponent(viewService, contextMenuService, confirmationService, conversationService, view) {
        this.viewService = viewService;
        this.contextMenuService = contextMenuService;
        this.confirmationService = confirmationService;
        this.conversationService = conversationService;
        this.view = view;
        this.viewSelected = new EventEmitter();
        this.isBusy = false;
        this.dragging = null;
    }
    TreeviewComponent.prototype.ngOnInit = function () {
    };
    TreeviewComponent.prototype.getViewChild = function (viewId) {
        var _this = this;
        this.viewService.getViewChildrenList(this.componentId, viewId).subscribe(function (result) {
            _this.childView = JSON.parse(result);
            _this.viewList.find(function (x) { return x.ViewID == viewId; }).ChildList = JSON.parse(result);
        });
    };
    TreeviewComponent.prototype.selectView = function (viewId) {
        var _this = this;
        this.viewSelected.emit(0);
        this.viewService.getViewDetail(this.componentId, viewId).subscribe(function (result) {
            _this.selectedView = viewId;
            _this.viewSelected.emit(result);
        }, function (error) {
            _this.viewSelected.emit(1);
        });
    };
    TreeviewComponent.prototype.viewSelectedChanged = function (result) {
        this.viewSelected.emit(result);
    };
    TreeviewComponent.prototype.pullPopup = function (view) {
        var _this = this;
        //$event.stopPropagation();
        this.confirmationService.confirm("Add Quick Phrase for " + view.ViewName, "", ["CANCEL", "OK"], true, "Add Quick Phrase...", true)
            .subscribe(function (respond) {
            if (respond.answer == "OK") {
                _this.isBusy = true;
                _this.conversationService.saveUtteranceForPersonalizedView(respond.inputText, view.ViewID).subscribe(function (result) {
                    console.log(result);
                });
            }
        });
    };
    TreeviewComponent.prototype.onContextMenu = function ($event, item) {
        this.currentItem = item.ViewID;
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                contextMenu: this.basicMenu,
                event: $event,
                item: item,
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    TreeviewComponent.prototype.onCloseContextMenu = function () {
        this.currentItem = '';
    };
    TreeviewComponent.prototype.handleDragStart = function (e) {
        //this.style.opacity = '0.4';
        this.dragging = e.target.closest('.list-item');
        if (e.target.classList.contains('list-item')) {
            this.dragging = e.target;
        }
        // console.log(this.dragging);
        e.dataTransfer.setData('text/html', this.dragging);
    };
    TreeviewComponent.prototype.handleDragOver = function (e) {
        if (this.draggable) {
            e.preventDefault();
            // var bounding = e.target.parentNode.getBoundingClientRect();
            // var targetItemParent = e.target.closest('.list-container');
            var target = e.target.closest('.list-item');
            var bounding = target.getBoundingClientRect();
            var offset = bounding.y + (bounding.height / 2);
            if (e.clientY - offset > 0) {
                target.style['border-bottom'] = '1px solid #3BAFDA';
                target.style['border-top'] = '';
            }
            else {
                target.style['border-top'] = '1px solid #3BAFDA';
                target.style['border-bottom'] = '';
            }
            return false;
        }
    };
    TreeviewComponent.prototype.handleDragLeave = function (e) {
        var target = e.target.closest('.list-item');
        target.style['border-bottom'] = '';
        target.style['border-top'] = '';
    };
    TreeviewComponent.prototype.handleDrop = function (e) {
        e.preventDefault();
        // handle the elements inside the list
        var targetItem = e.target.closest('.list-container');
        var target = e.target.closest('.list-item');
        // console.log(target);
        // console.log(target.nextSibling);
        if (target.style['border-bottom'] !== '') {
            // console.log('bottom');
            // console.log(targetItem.insertBefore(this.dragging, target.nextSibling));
            target.style['border-bottom'] = '';
            targetItem.insertBefore(this.dragging, target.nextSibling);
        }
        else {
            // console.log('top');
            // console.log(targetItem.insertBefore(this.dragging, target));
            target.style['border-top'] = '';
            targetItem.insertBefore(this.dragging, target);
        }
        return false;
    };
    TreeviewComponent.prototype.handleDragEnd = function (e) {
        // this/e.target is the source node.
        //this.style.opacity = '1';
        //[].forEach.call(cols, function (col) {
        //  col.classList.remove('over');
        //});
    };
    TreeviewComponent.prototype.dropMe = function (event) {
        if (event.source.children.length == 0) {
            // remove label and input if parent dont have child anymore
            console.log('zero');
        }
        else {
            // this has to work
        }
    };
    return TreeviewComponent;
}());
export { TreeviewComponent };
